<template>
  <div class="email-modal-wrapper" :class="{ 'message-feedback': response }">
    <b-modal
      id="sendEmailModal"
      class="emailModal"
      @shown="focusMyElement"
      ref="modal"
      @hide="handleCloseModal"
      :title="$t('dark-skin.email-modal.title')"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <b-form
        ref="form"
        class="needs-validation"
        :class="{ 'was-validated': $v.form.$anyDirty }"
        novalidate
        :hidden="response"
      >
        <div class="form-group">
          <label for="send-to" class="col-form-label d-none d-md-block">{{
            $t('dark-skin.email-modal.send-to')
          }}</label>
          <input
            type="email"
            class="form-control default"
            id="send-to"
            v-model="form.email"
            :placeholder="$t('dark-skin.email-modal.send-to')"
            ref="sendTo"
            required
          />
          <div class="invalid-feedback">
            <span v-if="!$v.form.email.email">
              {{ $t('dark-skin.email-modal.messages.invalid-email') }}
            </span>
            <span v-if="!$v.form.email.required">
              {{ $t('dark-skin.email-modal.messages.field-required') }}
            </span>
          </div>
        </div>
        <div class="form-group">
          <label for="from" class="col-form-label d-none d-md-block">
            {{ $t('dark-skin.email-modal.from') }}
          </label>
          <input
            type="text"
            class="form-control default"
            id="from"
            v-model="form.from"
            :placeholder="$t('dark-skin.email-modal.from')"
            required
          />
          <div class="invalid-feedback">
            <span v-if="!$v.form.from.required">
              {{ $t('dark-skin.email-modal.messages.field-required') }}
            </span>
          </div>
        </div>
        <div class="form-group">
          <label for="subject" class="col-form-label d-none d-md-block">
            {{ $t('dark-skin.email-modal.subject') }}
          </label>
          <input
            type="text"
            class="form-control default"
            id="subject"
            v-model="form.subject"
            :placeholder="$t('dark-skin.email-modal.subject')"
            required
          />
          <div class="invalid-feedback">
            <span v-if="!$v.form.subject.required">
              {{ $t('dark-skin.email-modal.messages.field-required') }}
            </span>
          </div>
        </div>
        <div
          :class="{ 'ck-editor__email__has-error': !$v.form.message.required && $v.form.$dirty }"
        >
          <label class="col-form-label d-none d-md-block">
            {{ $t('dark-skin.email-modal.message') }}
          </label>
          <textarea
            name=""
            id=""
            rows="5"
            v-model="form.message"
            :placeholder="$t('dark-skin.email-modal.message')"
            class="form-control default"
            required
          ></textarea>
          <div class="invalid-feedback d-block">
            <span v-if="!$v.form.message.required && $v.form.$dirty">
              {{ $t('dark-skin.email-modal.messages.field-required') }}
            </span>
          </div>
        </div>
      </b-form>
      <div slot="modal-footer" :hidden="response">
        <b-button
          size="sma"
          variant="primary"
          @click="send"
          :disabled="
            ((!$v.form.message.required || $v.form.$error) && $v.form.$dirty) || sendInProgress
          "
        >
          <span v-if="sendInProgress">
            {{ $t('dark-skin.email-modal.sending') }}
          </span>
          <span v-else="sendInProgress">{{ $t('dark-skin.email-modal.send') }}</span>
        </b-button>
      </div>
      <div class="emailModal__overlay" :class="response.class" v-if="response">
        <img
          v-if="response.class === 'success'"
          src="../../static/images/success.png"
          class="emailModal__overlay__image"
          alt=""
        />
        <img
          v-else="response.class === 'success'"
          src="../../static/images/error.png"
          class="emailModal__overlay__image"
          alt=""
        />
        <h2 class="emailModal__overlay__title">{{ response.title }}</h2>
        <p class="emailModal__overlay__message">{{ response.message }}</p>
        <button class="btn btn-primary emailModal__overlay__btn" @click="handleMessageButton">
          {{ response.button }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { HTTP } from '../../core/http/http-common';

import i18n from '../../i18n/index.js';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR.js';

export default {
  name: 'email-modal',
  components: {},
  validations: {
    form: {
      email: { required, email },
      from: { required },
      subject: { required },
      message: { required },
    },
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  props: {
    emailOptions: Object,
  },
  data() {
    return {
      form: {
        email: '',
        from: '',
        subject: '',
        message: '',
      },
      response: null,
      sendInProgress: false,
    };
  },
  watch: {},
  methods: {
    focusMyElement(e) {
      this.$refs.sendTo.focus();
    },
    send() {
      this.$v.form.$touch();
      if (this.$v.form.$error || !this.$v.form.message) {
        return;
      }

      const contentSendMail = {
        cryptedParam: this.emailOptions.cryptedParam,
        to: this.form.email,
        from: this.form.from,
        title: this.form.subject,
        message: this.form.message,
      };
      const URL = this.emailOptions.URL;
      let self = this;
      this.sendInProgress = true;
      HTTP.post(URL, contentSendMail, {
        emulateJSON: true,
      }).then(
        response => {
          if (response.data.code === 200) {
            self.response = {
              class: 'success',
              image: '../../static/images/success.png',
              title: i18n.t('dark-skin.email-modal.messages.thank-you'),
              message: i18n.t('dark-skin.email-modal.messages.message-sent'),
              button: i18n.t('dark-skin.email-modal.messages.back-to-video'),
            };
          } else {
            self.response = {
              class: 'error',
              image: '../../static/images/error.png',
              title: i18n.t('dark-skin.email-modal.messages.oops'),
              message: i18n.t('dark-skin.email-modal.messages.error-occurred'),
              button: i18n.t('dark-skin.email-modal.messages.try-again'),
            };
          }
          self.sendInProgress = false;
        },
        function(response) {
          console.error('api error', response);
          self.sendInProgress = false;
          self.response = {
            class: 'error',
            image: '../../static/images/error.png',
            title: i18n.t('dark-skin.email-modal.messages.oops'),
            message: i18n.t('dark-skin.email-modal.messages.error-occurred'),
            button: i18n.t('dark-skin.email-modal.messages.try-again'),
          };
        },
      );
    },
    handleMessageButton() {
      if (this.response.class === 'success') {
        this.$v.form.$reset();
        this.$refs.modal.hide();
        setTimeout(() => {
          this.form = {
            email: '',
            from: '',
            subject: '',
            message: '',
          };
        }, 500);
      }
      setTimeout(() => {
        this.response = null;
      }, 500);
    },
    handleCloseModal() {
      this.$v.form.$reset();
      this.response = null;
      this.form = {
        email: '',
        from: '',
        subject: '',
        message: '',
      };
    },
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem('lang-player');
  },
};
</script>

<style lang="scss">
$success-color: #4eb002;
$error-color: #fd5d38;

body {
  --ck-z-default: 1051; /* Bootstrap modal + 1 */
  --ck-z-modal: calc(var(--ck-z-default) + 999);
  --ck-color-base-border: #ced4da;
  --ck-color-toolbar-background: #ffffff;

  .ck.ck-button {
    -webkit-appearance: none;
  }
  .ck-editor__editable {
    min-height: 150px;
  }
  .ck-editor__email__has-error {
    --ck-color-base-border: #dc3545;
    --ck-focus-ring: 1px solid #dc3545;
  }
  .ck.ck-icon {
    --ck-icon-size: 20px;
    --ck-icon-size: 20px;
    font-size: 12px;
  }
}

.email-modal-wrapper {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  /deep/ #sendEmailModal {
    .modal-content {
      border-radius: 0;
      color: #333333;
      .modal-header {
        background-color: #343a40;
        color: #ffffff;
        border-radius: 0;
        .modal-title {
          font-size: 1em;
        }
        .close {
          color: #ffffff;
          font-size: 1.2rem;
          font-weight: 500;
          padding: 1.2rem;
          line-height: 1;
          &:hover {
            color: #ffffff;
          }
        }
      }
      .modal-body {
        overflow-y: auto;
        .form-control {
          border-radius: 2px;
          &:focus {
            box-shadow: none;
          }
        }
        .invalid-feedback {
          font-size: 80% !important;
          color: #dc3545 !important;
        }
        button.ck.ck-button.ck-dropdown__button {
          font-size: 13px !important;
        }
      }
      .modal-footer {
        border: none;
        background: rgba(55, 60, 66, 0.05);
        .btn-secondary {
          background-color: transparent;
          color: #373c42;
          border-color: transparent;
        }
        .btn-primary {
          background-color: #373c42;
          border-color: #373c42;
          color: #fff !important;
          &:not(:disabled):not(.disabled):active:focus {
            box-shadow: none;
          }
        }
      }
    }
  }

  &.message-feedback {
    /deep/ .modal-footer {
      background-color: #ffffff !important;
    }
  }

  @media (max-width: 767px) {
    #sendEmailModal {
      padding: 0 !important;
      .modal-dialog {
        max-width: 100%;
        margin: 0;
        .modal-body {
          max-height: calc(100vh - 130px);
        }
      }
    }
  }

  @media (min-width: 768px) {
    .form-control::placeholder {
      color: white;
      display: none;
    }
    .modal-body {
      max-height: calc(100vh - 190px);
    }
  }
}

.emailModal {
  &__overlay {
    text-align: center;
    &.success &__title {
      color: $success-color;
    }
    &.success &__btn,
    &.error &__btn:active {
      background-color: $success-color !important;
      border-color: $success-color !important;
    }
    &.error &__title {
      color: $error-color;
    }
    &.error &__btn,
    &.error &__btn:active {
      background-color: $error-color !important;
      border-color: $error-color !important;
    }
    &__message {
      color: #757575;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/EmailModal.vue